<template>
  <span :class="displayType" v-html="displayType === 'text' ? locationTypesText : locationTypesIcons">
  </span>
</template>

<script>
export default {
  props: {
    documentLocationTypes: { type: String, required: true },
    displayType: { type: String, required: false, default: 'text'}
  },
  computed: {
    locationTypesText: function() {
      let locationTypes = JSON.parse(this.documentLocationTypes);
      let translatedLocationTypes = [];
      let _this = this;
      locationTypes.forEach(function(locationType){
        translatedLocationTypes.push(_this.translate('label.location.' + locationType));
      })
      return translatedLocationTypes.join(', ');
    },
    locationTypesIcons: function() {
      let locationTypes = JSON.parse(this.documentLocationTypes);
      let locationTypeIcons = [];
      let _this = this;
      let imageNames = {
        'place_of_writing': 'ico-writing.svg',
        'place_of_goods': 'ico-goods.svg',
        'mentioned_place': 'ico-mentioned.svg'
      };
      locationTypes.forEach(function(locationType){
        locationTypeIcons.push('<img src="/img/' + imageNames[locationType] + '" alt="' + _this.translate('label.location.' + locationType) + '" title="' + _this.translate('label.location.' + locationType) + '">');
      })
      return locationTypeIcons.join('');
    }
  }
}
</script>

<style lang="scss">
  .icons {
      display: inline-block;
      margin-top: -0.3rem;
      vertical-align: middle;
      padding-right: .25rem;
      img { padding-right: .125rem; }
  }
</style>


